// extracted by mini-css-extract-plugin
export default {"activeColor":"TypeSeries_activeColor__9qjg1","textEllipsis":"TypeSeries_textEllipsis__Tb5vv"};